import axios from 'axios';
import { IInputStatus } from '../../../interface/progress.interface';
import { IInputType } from '../../../interface/steps.interface';
import { checkTooltipHandler } from '../utils/tooltip/tooltipHandler';
import isValidation from '../utils/validation/isValidation';

type Status = 1 | 0
interface IData {
  [key: string]: {
    res: number,
    value: string
  }
}

interface IResponse {
  res: 1| 0
  msg: string
  data: IData
}
const VALIDATE_URL = '//svc.l4fs.com/sync/check/fields_mx/'

const acceptValid = ['0', 0]

class ChangeInputValue {
  private timers: Record<string, any> = {}

  constructor(
    private rootStore: any,
  ) { }

  /**
   * Эта функция отвечает за обновление значения указанного поля ввода, обработку зависимостей,
   * планирование проверки значения через API и обновление статуса поля ввода соответственно.
   *
   * @param {string} name - Название поля ввода, которое требуется обновить.
   * @param {string} newValue - Новое значение, которое должно быть установлено для поля ввода.
   */
  public async changeValues(name: string, newValue: string) {
    try {
      console.log('newValue', name, newValue)
      const { StepsStore, ProgressStore } = this.rootStore;
      const { currentStep, values, inputsData } = StepsStore;

      // Проверка, отличается ли новое значение от текущего
      // if (newValue !== values[name]) {
        StepsStore.invalidInputs = {
          ...StepsStore.invalidInputs,
          [name]: false
        }
        if (newValue === '' || newValue === undefined) {
          ProgressStore.changeStatus(name, IInputStatus.none, currentStep)
        } else if (name === 'accept' && acceptValid.includes(newValue)) {
          console.log('acceptValid')
          ProgressStore.changeStatus(name, IInputStatus.none, currentStep)
        } else if (name === 'birthday' && !/[0-9]/.test(newValue)) {
          ProgressStore.changeStatus(name, IInputStatus.none, currentStep)
        } else {
          ProgressStore.changeStatus(name, IInputStatus.change, currentStep)
          console.log('changeValues', name, newValue)
          this.validation(name, newValue)
        }

        // Обработка зависимостей между полями ввода
        const { isDep, depName } = this.handleDependency(name, newValue, currentStep);

        // Обновление значений полей ввода
        StepsStore.values[name] = newValue;
        if (isDep) {
          StepsStore.values[depName] = '';
        }

        // Проверка и обработка всплывающей подсказки
        checkTooltipHandler(name, StepsStore);
      
    } catch (error) {
      console.log(error);
    }
  }

  private makeData = (name: string, newValue: string) => {
    const data = {
      //@ts-ignore
      lang: window.lang || 'es',
      advanced: 1,
      fields: {
        [name]: newValue
      }
    }
    return data
  }

  private async validation(name: string, newValue: string) {
    const { validsAsync } = this.rootStore.StepsStore
    if (validsAsync[name] && validsAsync[name].controller) {
      validsAsync[name].controller.abort(); // Abort the previous request
    }

    // создаем экземпляр отмены
    const controller = new AbortController();
    
    const data = this.makeData(name, newValue)
    // сохраняем источник отмены для текущего запроса
    const prom = axios.post(VALIDATE_URL, data)
   .then((res) => {
      this.validationComplite(res.data, name, newValue);
      validsAsync[name] = false;
    }).catch(error => {
      console.error(`Error in validation request: ${error}`);
    })
    validsAsync[name] = {
      promise: prom,
      controller
    }
  }

  private validationComplite(data: any, name: string, newValue: string) {
    const { StepsStore, ProgressStore } = this.rootStore;
    const { currentStep, values, inputsData } = StepsStore;
    console.log('data', data)
    if (data.res === 1) {
      ProgressStore.changeStatus(name, IInputStatus.success, currentStep);
      this.setValidValues(data.data)
      // this.localStorageSave(name, newValue)
    } else if (data.res === 0) {
      this.handleApiError(data, name, currentStep);
    }
  }

  private setValidValues(data: any) {
    const { StepsStore } = this.rootStore;
    Object.keys(data).forEach((key) => {
      const value = data[key].value
      StepsStore.values[key] = value
    })
  }

  private async handleApiError(apiStatus: any, name: string, currentStep: number) {
    const newApiErrors = {
      ...this.rootStore.StepsStore.apiErrors,
      ...apiStatus.data,
    }
    this.rootStore.StepsStore.apiErrors = newApiErrors;
    const errors = { ...apiStatus.data };
    const newInvalidInputs = {
      ...this.rootStore.StepsStore.invalidInputs,
      ...errors,
    };
    //@ts-ignore
    this.rootStore.StepsStore.invalidInputs = newInvalidInputs;
    this.rootStore.ProgressStore.changeStatus(
      name,
      IInputStatus.apiError,
      currentStep
    );
  }

  private localStorageSave(name: string, value: string) {
    let localStoreValues = localStorage.getItem('values')
      let localValues
      if (localStoreValues) {
        localValues = JSON.parse(localStoreValues)
        localValues[name] = value
      } else {
        localValues = {[name]: value}
      }
      localStorage.setItem('values', JSON.stringify(localValues))
  }

  private handleDependency(name: string, newValue: string, currentStep: number) {
    let isDep = false;
    let depName = null;
    const dependencies = this.rootStore.StepsStore.dependencies
    if (dependencies[name]) {
      depName = dependencies[name].name;
      if (String(dependencies[name].value) === String(newValue)) {
        this.rootStore.ProgressStore.changeStatus(
          depName,
          IInputStatus.none,
          currentStep
        );
      } else {
        this.rootStore.ProgressStore.changeStatus(
          depName,
          IInputStatus.disabled,
          currentStep
        );

        isDep = true;
      }
    }

    return { isDep, depName };
  }

}

export default ChangeInputValue